var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mb-2"},[_vm._v(" 倉儲到期說明： ")]),_c('div',{staticClass:"mb-2"},[_vm._v(" 如您未能在免費倉儲期限內完成集運，系統將自動視為您已放棄包裹並刪除到期包裹。 請務必在免費倉儲期限內完成集運。 ")])])
}]

export { render, staticRenderFns }